module.exports = __webpack_public_path__ + "7563f4c703c8116ceab725a1a8ff238d.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/159.png
// module id = 1754
// module chunks = 2